// Full-document render of the Oscar change-password view: PageSkeleton
// wrapping the legacy sealy breadcrumb shell ("Your Account / Change
// Password") and the password form rendered as a native React field tree.
import React from "react";

import { templates } from "@reactivated";

import { AccountBreadcrumbShell } from "../components/AccountBreadcrumbShell";
import { AccountForm } from "../components/AccountForm";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.ChangePasswordDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AccountBreadcrumbShell
            crumbs={[
                { label: "Your Account", href: props.profile_url },
                { label: "Change Password" },
            ]}
            heading="Change Password"
        >
            <AccountForm {...props} />
        </AccountBreadcrumbShell>
    </PageSkeleton>
);
